import { App, KernelRouteEndpoint, KernelRoute } from "../../../kernel/kernel";
import raf from "raf";

/**
 * Dashboard route
 *
 * @extends KernelRoute
 */
class OrganisationsRoute extends KernelRoute {

    /**
     * When the user hits the index page, show the index page
     */
    @KernelRouteEndpoint("/organisations(/)")
    route () {
        System.import("./index").then(View => {
            const view = new View.default();

            raf(_ => App.contentRegion.show(view));
        });
    }

}

export default OrganisationsRoute;



// WEBPACK FOOTER //
// ./public/domain/views/organisations/organisations.route.js